import { useState } from "react";
import {
  addDays,
  addMonths,
  endOfMonth,
  startOfMonth,
  subDays,
  subMonths,
} from "date-fns";
import { EventsCalendar } from "@circle-react/components/AllEvents/CalendarView/EventsCalendar";
import { TopicFilters } from "@circle-react/components/Spaces/TopicFilters";
import { useFilters } from "@circle-react/components/Spaces/TopicFilters/hooks/useFilters";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { PostsDetailsContextProvider } from "@circle-react/contexts/postsDetailsContext";
import { usePostList } from "@circle-react/hooks/posts/usePostList";
import { Loader } from "@circle-react-shared/uikit/Loader";

export const SpaceCalendarView = () => {
  const initialDate = subDays(startOfMonth(new Date()), 7);
  const [currentDate, setCurrentDate] = useState(initialDate);
  const endDate = addDays(addMonths(endOfMonth(currentDate), 2), 7);

  const { data: space } = useCurrentSpaceContext();
  const { currentFilters } = useFilters();
  const {
    posts: events,
    onPostChange: onChange,
    onPostDestroy: onDestroy,
    mapPages,
    isLoading,
  } = usePostList({
    sort: "asc",
    per_page: 150,
    past_events: false,
    used_on: space?.display_view,
    filter_date: {
      start_date: currentDate.toDateString(),
      end_date: endDate.toDateString(),
    },
    status: "all",
    topics: Array.from(currentFilters),
  });
  const hasTopics = Number(space?.topics_count) > 0;
  const perPagePostIds = mapPages((page: any) =>
    page.records.map((post: any) => post.id),
  );

  const fetchNextPage = () => {
    setCurrentDate(addMonths(currentDate, 1));
  };

  const fetchPrevPage = () => {
    setCurrentDate(subMonths(currentDate, 1));
  };

  if (events.length == 0 && isLoading) {
    return <Loader center />;
  }

  return (
    <div className="mx-auto mb-6 w-full px-6 pb-10 pt-6 sm:px-0 md:pt-0 lg:pb-0">
      <PostsDetailsContextProvider
        perPagePostIds={perPagePostIds}
        spaceId={space?.id}
      >
        {hasTopics && (
          <div className="mb-6">
            <TopicFilters inline />
          </div>
        )}
        <EventsCalendar
          events={events}
          onChange={onChange}
          onDestroy={onDestroy}
          fetchNextPage={fetchNextPage}
          fetchPrevPage={fetchPrevPage}
        />
      </PostsDetailsContextProvider>
    </div>
  );
};
